import * as type from '../types/overview'

export const changeOverviewModal = payload => {
    return{
        type: type.CHANGE_OVERVIEW_MODALS,
        modal: payload
    }
}

export const changeOverviewFilter = payload => {
    return{
        type: type.SET_FILTER_TYPE,
        info: payload
    }
}

export const retrieveOverviewResponses = payload => {
    return{
        type: type.REQUEST_RESPONSE_DATA,
        payload: payload
    }
}

export const resetOverviewResponses = () => {
    return{
        type: type.RESET_RESPONSE_DATA
    }
}

export const setActiveRangeType = payload => {
    return{
        type: type.SET_ACTIVE_RANGE_TYPE,
        payload: payload
    }
}

export const resetActiveRangeType = () => {
    return{
        type: type.RESET_ACTIVE_RANGE_TYPE
    }
}

export const retrieveOverviewSales = payload => {
    return{
        type: type.REQUEST_SALES_DATA,
        payload: payload
    }
}

export const resetOverviewSales = () => {
    return{
        type: type.RESET_SALES_DATA
    }
}

export const retrieveOverviewDeliveries = payload => {
    return{
        type: type.REQUEST_DELIVERIES_DATA,
        payload: payload
    }
}

export const resetOverviewDeliveries = () => {
    return{
        type: type.RESET_DELIVERIES_DATA
    }
}


export const retrieveOverviewRevenue = payload => {
    return{
        type: type.REQUEST_REVENUE_DATA,
        payload: payload
    }
}

export const resetOverviewRevenue = () => {
    return{
        type: type.RESET_REVENUE_DATA
    }
}

export const retrieveOverviewClients = payload => {
    return{
        type: type.REQUEST_CLIENTS_DATA,
        payload: payload
    }
}

export const resetOverviewClients = () => {
    return{
        type: type.RESET_CLIENTS_DATA
    }
}

export const retrieveSelectionYears = payload => {
    return{
        type: type.REQUEST_SELECTION_YEARS,
        payload: payload
    }
}

export const resetSelectionYears = () => {
    return{
        type: type.RESET_SELECTION_YEARS
    }
}

export const setActiveSelectionYear = payload => {
    return{
        type: type.SET_ACTIVE_SELECTION_YEAR,
        year: payload
    }
}

export const resetActiveSelectionYear = () => {
    return{
        type: type.RESET_ACTIVE_SELECTION_YEAR
    }
}

export const setGoalType = payload => {
    return{
        type: type.SET_GOAL_TYPE,
        goal: payload
    }
}

export const resetGoalType = () => {
    return{
        type: type.RESET_GOAL_TYPE
    }
}

export const retrieveGoalDisplay = payload => {
    return{
        type: type.REQUEST_GOAL_DATA,
        payload: payload
    }
}

export const resetGoalDisplay = () => {
    return{
        type: type.RESET_GOAL_DATA
    }
}

export const requestAddNewGoal = payload => {
    return{
        type: type.REQUEST_CREATE_NEW_GOAL,
        payload: payload
    }
}

export const resetAddNewGoal = () => {
    return{
        type: type.RESET_CREATE_NEW_GOAL
    }
}

export const requestDeleteGoal = payload => {
    return{
        type: type.REQUEST_DELETE_SINGLE_GOAL,
        payload: payload
    }
}

export const resetDeleteGoal = () => {
    return{
        type: type.RESET_DELETE_SINGLE_GOAL
    }
}

export const requestUpdateGoal = payload => {
    return{
        type: type.REQUEST_UPDATE_SINGLE_GOAL,
        payload: payload
    }
}

export const resetUpdateGoal = () => {
    return{
        type: type.RESET_UPDATE_SINGLE_GOAL
    }
}

export const setActiveUpdateGoal = payload => {
    return {
        type: type.SET_ACTIVE_UPDATE_GOAL,
        payload: payload
    }
}

export const resetActiveUpdateGoal = () => {
    return {
        type: type.RESET_ACTIVE_UPDATE_GOAL
    }
}